<template>
  <Popup
    v-model="popupShow2"
    closeable
    round
    @close="closePopup"
    position="bottom"
    :style="{ height: '30%' }"
  >
    <p class="popup-p popup-p1">计算方式</p>
    <p class="popup-p popup-p2">{{popupTitle}}</p>
    <p class="popup-p popup-p3">{{popupContent}}</p>
  </Popup>
</template>
 
<script>
  import {Popup} from 'vant';
  import explain from '../../../static/js/calculationExplain'
  export default {
    name: 'POPUPWIN',
    data () {
      return {
        popupTitle:'弹框标题',//弹框标题
        popupContent:'弹框内容',//弹框标题
        popupShow2:false
      }
    },
    components: {Popup}, 
    props:{
      popupShow:Boolean,
      keyWords:String
    },
    mounted() {
      this.popupShow2 = this.popupShow;
      this.popupTitle = this.keyWords.split('_')[0];
      this.popupContent = explain.explain[this.keyWords];
    },
    methods: {
      closePopup(){
        console.log('close')
        this.popupShow = false;
        this.$emit('childRe',false);
      }
    },  
  }
</script>
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/components/popupWin.vue